import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

// Definición de defaults

export const defaultPerfil: PerfilProps = {
    ...defaultHttpResponse,
    correoElectronico: '',
    curp: '',
    rfc: '',
    nombres: '',
    apellido1: '',
    apellido2: '',
    puesto: '',
    tipoUsuario: '',
    firmaElectronica: false,
    contrasena: '',
    roles: [],
    diasExpiracionFirmaElectronica: 0,
    unidad: '',
    delegado: '',
}

export const defaultUsuarioPoderEnLinea: UsuarioPoderEnLineaProps = {
    id: '',
    nombre: '',
    apellido1: '',
    apellido2: '',
    correoElectronico: '',
    solicitante: '',
    telefonoCelular: '',
}

export const defaultBuscarUsuarioPoderEnLinea: BuscarUsuarioPoderEnLineaResponse = {
    ...defaultHttpResponse,
    ...defaultUsuarioPoderEnLinea,
}

export const defaultUsuario: UsuarioResponse = {
    ...defaultHttpResponse,
    idUsuario: 0,
    curp: '',
    nombres: '',
    apellido1: '',
    apellido2: '',
    correoElectronico: '',
    telefono: '',
    contrasena: '',
    activo: false,
    idPuesto: 0,
    puesto: '',
    idTipoUsuario: 0,
    tipoUsuario: '',
    restablecerContrasena: false,
    idUsuarioFirmaElectronica: 0,
    contrasenaFirmaElectronica: '',
    fechaExpiracionFirmaElectronica: '',
    idUsuarioDelegado: 0,
    idUsuarioAgendamiento: 0,
    idUnidad: 0,
    unidad: '',
    idAutoridad: 0,
    autoridad: '',
    idUsuarioExpedienteVirtual: 0,
    diasExpiraFirmaElectronica: 0,
    roles: [],
    mecanografos: [],
}

export const defaultBuscarUsuario: BuscarUsuarioResponse = {
    ...defaultHttpResponse,
}

// Creación de interfaces

export interface UsuarioProps {
    idUsuario:                          number;
    curp:                               string;
    nombres:                            string;
    apellido1:                          string;
    apellido2:                          string;
    correoElectronico:                  string;
    telefono:                           string;
    contrasena:                         string;
    activo:                             boolean;
    idTipoUsuario:                      number;
    tipoUsuario?:                       string;
    idUsuarioFirmaElectronica:          number;
    contrasenaFirmaElectronica:         string;
    fechaExpiracionFirmaElectronica:    string;       
    idPuesto:                           number;
    puesto:                             string;
    restablecerContrasena:              boolean;
    roles:                              RolUsuarioProps[];
    idUsuarioDelegado:                  number;
    idUsuarioAgendamiento:              number;
    idUnidad:                           number;
    unidad:                             string;
    idAutoridad:                        number;
    autoridad:                          string;
    idUsuarioExpedienteVirtual:         number;
    diasExpiraFirmaElectronica:         number;
    mecanografos:                       UsuarioMecanografoProps[];
}

export interface BuscarUsuarioResponse extends HttpResponse{
    curp?:                              string,
    rfc?:                               string,
    nombres?:                           string,
    apellido_Primero?:                  string,
    apellido_Segundo?:                  string,
    email?:                             string,
    sexo?:                              string,
    numero_Empleado?:                   number,
}

/* -------------------------------------------- */

export interface AgregarUsuarioParams {   
    curp:                               string;
    nombres:                            string;
    apellido1:                          string;
    apellido2:                          string;
    correoElectronico:                  string;
    idPuesto:                           number;
    idTipoUsuario:                      number;
    fechaNacimiento?:                   string;
    idSexo?:                            number;
    entidadNacimiento?:                 string;
}

export interface ActualizarUsuarioParams {
    idUsuario:                          number;
    curp:                               string;
    nombres:                            string;
    apellido1:                          string;
    apellido2:                          string;
    idPuesto:                           number;
    fechaNacimiento?:                   string;
    idSexo?:                            number;
    entidadNacimiento?:                 string;
}

export interface ActualizarConfiguracionUsuarioParams {
    idUsuario:                          number;
    correoElectronico:                  string;
    telefono:                           string;
    contrasena:                         string;
    activo:                             boolean;
    idTipoUsuario:                      number;   
    idUsuarioFirmaElectronica:          number;
    contrasenaFirmaElectronica:         string;
    fechaExpiracionFirmaElectronica:    string;       
    idPuesto:                           number;  
    restablecerContrasena:              boolean;    
    idUsuarioDelegado:                  number;
    idUsuarioAgendamiento:              number;
    idUnidad:                           number;
    idAutoridad:                        number;
    idUsuarioExpedienteVirtual:         number;
}

export interface ActualizarPermisosUsuarioParams {   
    idUsuario:                          number;
    roles:                              number[];
}

export interface RolUsuarioProps {
    id:                 number;
    descripcion:        string;
    selected:           boolean;
}

export interface UsuarioDelegadoProps {
    idUsuario:          number;
    nombreCompleto:     string;
}

export interface UsuarioResponse extends HttpResponse, UsuarioProps { }

export interface RolesUsuarioProps {
    ModuloNuevoProceso:                                  boolean,
    ModuloBusqueda:                                      boolean,
    ModuloConsultas:                                     boolean,
    ModuloCatalogos:                                     boolean,
    ModuloLibrosElectronicos:                            boolean,
    ElaboradorAcuerdo:                                   boolean,
    ValidadorAcuerdo:                                    boolean,
    AutorizadorAcuerdo:                                  boolean,
    VisualizadorAcuerdo:                                 boolean,
    ElaboradorAcuerdoOficioso:                           boolean,
    GeneradorNotificacion:                               boolean,
    CelebradorAudiencia:                                 boolean,
    ElaboradorActaAudiencia:                             boolean,
    ValidadorActaAudiencia:                              boolean,
    AutorizadorActaAudiencia:                            boolean,
    VisualizadorActaAudiencia:                           boolean,
    EscaneadorAnexosEnAudiencia:                         boolean,
    ElaboradorSentencia:                                 boolean,
    AutorizadorSentencia:                                boolean,
    VisualizadorSentencia:                               boolean,
    ElaboradorSentenciaPublica:                          boolean,
    AutorizadorSentenciaPublica:                         boolean,
    VisualizadorSentenciaPublica:                        boolean,
    ElaboradorOficio:                                    boolean,
    AutorizadorOficio:                                   boolean,
    VisualizadorOficio:                                  boolean,
    ElaboradorExhortoLibrado:                            boolean,
    AutorizadorExhortoLibrado:                           boolean,
    VisualizadorExhortoLibrado:                          boolean,
    GeneradorListaAcuerdos:                              boolean,
    GeneradorListaEstrados:                              boolean,
    GeneradorListadoEnvio:                               boolean,
    GeneradorCaratulas:                                  boolean,
    ElaboradorCertificacion:                             boolean,
    VisualizadorConsultaCertificaciones:                 boolean,
    VisualizadorExpedienteVirtual:                       boolean,
    VisualizadorConsultaAudiencias:                      boolean,
    VisualizadorConsultaTramitesRecibidos:               boolean,
    VisualizadorConsultaAcuerdos:                        boolean,
    VisualizadorConsultaOficios:                         boolean,
    VisualizadorConsultaExhortosLibrados:                boolean,
    VisualizadorConsultaNotificaciones:                  boolean,
    VisualizadorConsultaExpedientesPorEtapaProcesal:     boolean,
    VisualizadorConsultaIncidentes:                      boolean,
    RegistrarExpedienteAnterior:                         boolean,
    RegistrarExhortoAnterior:                            boolean,
}   

export interface PerfilProps extends HttpResponse {
    correoElectronico:              string;
    curp:                           string;
    rfc:                            string;
    nombres:                        string;
    apellido1:                      string;
    apellido2:                      string;
    puesto:                         string;
    tipoUsuario:                    string;
    firmaElectronica:               boolean;
    contrasena:                     string;
    roles:                          RolUsuarioProps[];
    diasExpiracionFirmaElectronica: number;
    unidad:                         string;
    delegado:                       string;
}

export interface UsuarioReasignacionCancelacionResponse {
    id:                             string;
    idUsuario:                      number;
    nombreCompleto:                 string;
}

export interface UsuarioJuezProps {
    idUsuario:          number;
    nombreCompleto:     string;
}

export interface UsuarioMecanografoProps {
    idUsuario:                  number;
    usuario:                    string;
    totalAcuerdos:              number;
    totalAcuerdosPendientes:    number;
}

export interface UsuarioPoderEnLineaProps {
    id:                 string;
    solicitante:        string;
    nombre:             string;
    apellido1:          string;
    apellido2:          string;
    correoElectronico:  string;
    telefonoCelular:    string;
}

export interface BuscarUsuarioPoderEnLineaParams {
    correoElectronico:  string;
    telefonoCelular:    string;
}

export interface BuscarUsuarioPoderEnLineaResponse extends HttpResponse, UsuarioPoderEnLineaProps {}

export interface ActualizarMecanografosUsuarioParams {   
    idUsuario:                          number;
    mecanografos:                       number[];
}

export interface MecanografoProps {
    idUsuario:                  number;
    usuario:                    string;
}

export interface UsuarioNotificacionProps {
    id:                 number;
    nombreCompleto:     string;
}

export interface UsuarioSecretarioProps {
    id:                 number;
    nombreCompleto:     string;
}

export interface UsuarioAcuerdoProps {
    id:                 number;
    nombreCompleto:     string;
}

export interface UsuarioOficiosProps {
    id:                 number;
    nombreCompleto:     string;
}

export interface UsuarioExhortoLibradoProps {
    id:                 number;
    nombreCompleto:     string;
}

export interface UsuarioCertificacionProps {
    id:                 number;
    nombreCompleto:     string;
}
